import type { FaireProductEntity } from "../../entity_types/product";

export const p_epnygzha74: FaireProductEntity = {
  token: "p_epnygzha74",
  type: "product",
  name: "hibiscus tropical mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/81fa0b7676af05237d471bda053a7b728e0feedd5399a75e984f5deac69fe35b.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n\n• single card + envelope\n• blank inside\n• 2.5" x 3.5"\n• Printed on 120lb superfine paper',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:53.467Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
